/**
 * Adds JS listener to toggle CSS classes on any element with .scrollfade
 * CSS can then be used to add opacity/mask gradients to fade out left/right edges
 */

const scrollFade = {
	init() {
		const scroll = new Event('scroll');

		document.querySelectorAll('.scrollfade').forEach((elem) => {
			// Listen for scrolling.
			elem.addEventListener('scroll', () => {
				const viewWidth = elem.offsetWidth;
				const elemWidth = elem.scrollWidth;

				// If element is wider than its viewable area, add classes indicating which sides it 'bleeds' off of.
				if (elemWidth > viewWidth) {
					const extra = elemWidth - viewWidth;
					if (elem.scrollLeft === 0) {
						elem.classList.remove('sf-left');
					} else {
						elem.classList.add('sf-left');
					}
					if (elem.scrollLeft >= extra) {
						elem.classList.remove('sf-right');
					} else {
						elem.classList.add('sf-right');
					}
				}
			}, { passive: true });
			elem.dispatchEvent(scroll);
		});
	},
};

scrollFade.init();
